import { param2Obj } from 'src/utils'

const userMap = {
  administrator: {
    roles: ['administrator'],
    token: 'administrator',
    introduction: '我是超级管理员',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: 'Super Admin'
  },
  college_administrator: {
    roles: ['college_administrator'],
    token: 'college_administrator',
    introduction: '我是教学秘书',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: 'Normal Editor'
  },
  teacher: {
    roles: ['teacher'],
    token: 'teacher',
    introduction: '我是李老师',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: '普通老师'
  },
  student: {
    roles: ['student'],
    token: 'student',
    introduction: '我是学生哟',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: '学生'
  },
  publisher_administrator: {
    roles: ['publisher_administrator'],
    token: 'publisher_administrator',
    introduction: '我是出版社管理员',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: '出版社管理员'
  },
  publisher: {
    roles: ['publisher'],
    token: 'publisher',
    introduction: '我是出版社普通帐号',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: '社普通帐号'
  },
  school_administrator: {
    roles: ['school_administrator'],
    token: 'school_administrator',
    introduction: '我是学校管理员',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    name: '学校管理员'
  }
}

export default {
  loginByUsername: config => {
    const { username } = JSON.parse(config.body)
    return userMap[username]
  },
  getUserInfo: config => {
    const { token } = param2Obj(config.url)
    if (userMap[token]) {
      return userMap[token]
    } else {
      return false
    }
  },
  logout: () => 'success'
}



// WEBPACK FOOTER //
// ./src/mock/login.js